import axios from 'axios'

let prefix = ''
//创建axios的一个实例
var instance = axios.create({
  // baseURL: 'http://10.4.26.2:8106',
  timeout: 6000 
})


//------------------- 一、请求拦截器 忽略
instance.interceptors.request.use(function (config) {
  if (localStorage.getItem('token')) {
    // config.headers['x-access-token'] = localStorage.getItem('token')
    // config.headers['Accept-Language'] = localStorage.getItem('lang')
    // config.headers['lang'] = localStorage.getItem('lang')
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

//----------------- 二、响应拦截器 忽略
instance.interceptors.response.use(function (response) {

  return response.data;
}, function (error) {
  // 对响应错误做点什么
  // console.log(error.response);
  return Promise.reject(error);
});

/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} method 请求的方法：get、post、delete、put
 * @param {String} url   请求的url:
 * @param {Object} data  请求的参数
 * @returns {Promise}   返回一个promise对象，其实就相当于axios请求数据的返回值
 */
export default function (method, url, data = null) {
  url = prefix + url;
  method = method.toLowerCase();
  if (method == 'post') {
    return instance.post(url, data)
  } else if (method == 'get') {
    return instance.get(url, { params: data })
  } else if (method == 'delete') {
    return instance.delete(url, { data: data })
  } else if (method == 'put') {
    return instance.put(url, data) 
  } else if (method == 'upload') {
    return axios({
      url: url,
      data: data,
      method: 'post',
      headers: {
        'Transfer-Encoding':'chunked',
        'Content-Type': 'multipart/form-data' // 文件上传
      }
    })
  } else if (method == 'getchunked') {
    return axios({
      url: url,
      data: data,
      method: 'get',
      headers: {
        'Transfer-Encoding':'chunked'
      }
    })
  } else if (method == 'postchunked') {
    return axios({
      url: url,
      data: data,
      method: 'post',
      headers: {
        'Transfer-Encoding':'chunked'
      }
    })
  } else {
    console.error('未知的method' + method)
    return false
  }
}